import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { BankDetail } from './bankDetail';


@JsonObject('BankSearchResults')
export class BankSearchResults extends SearchResults {
    @JsonProperty('results', [BankDetail])
    results: BankDetail[] = [];
}
